import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

const useStyles = makeStyles(fillInTheBlanksStyles)

export default function FillInTheBlanks ({context, question}) {

  const classes = useStyles()
  const {translate} = context

  const [phrases, setPhrases] = React.useState(question.answer.phrases.map(p => ({...p, value: ''})))

  return (<Box className={classes.root}>
    <Box className={classes.wrapper}>
      {question.answer.phrases.map(({phrase, blanked, value}, index) =>
        blanked
          ? (<input
            key={index}
            className={clsx(classes.input, classes.phrase)}
            type="text"
            value={phrase}
            readOnly
            />)
          : (<Box
            key={index}
            className={classes.phrase}>{phrase}</Box>)
      )}
    </Box>
  </Box>)
}


function fillInTheBlanksStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      padding: '35px 0',
      fontSize: '12pt',
    },
    wrapper: {
      display: 'flex'
    },
    phrase: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginRight: 10,
      '&:last-child': {
        marginLeft: 0
      }
    },
    input: {
        border: 'none',
        borderBottom: 'solid 1px black',
    },
  }
}
